import React, { HTMLAttributes, ReactNode } from "react"
import clsx from "clsx"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import { Label } from "./Label"
import styles from "./Typography.module.css"

export type PProps = BaseStyles &
  HTMLAttributes<HTMLDivElement> & {
    children: ReactNode
    label?: string
    $labelColor?: string
    $small?: boolean
    $fontSize?: string
  }
export const P = ({
  children,
  label,
  $labelColor = "third",
  $small,
  $fontSize,
  className = "",
  style = {},
  ...rest
}: PProps & { className?: string; style?: React.CSSProperties }) => {
  const generatedStyles = generateStylesFromProps(rest)

  const pClasses = clsx(
    styles.p,
    {
      [styles.small]: $small,
    },
    className,
  )

  const pStyles = {
    ...generatedStyles,
    fontSize: $fontSize ? `var(--font-size-${$fontSize.toLowerCase()})` : undefined,
    marginBottom: "0",
    ...style,
  }

  if (label) {
    const wrapperStyles = {
      ...generatedStyles,
      ...style,
    }

    return (
      <div className={styles.pWrapper} style={wrapperStyles}>
        {label && (
          <Label $type="third" $color={$labelColor} $marginBottom="XXS">
            {label}
          </Label>
        )}
        <p className={pClasses} style={pStyles}>
          {children}
        </p>
      </div>
    )
  }

  return (
    <p className={pClasses} style={{ ...pStyles, ...generatedStyles }}>
      {children}
    </p>
  )
}

export default P
